import store from '@/store'
import { extractRoleCode, getHomeRouteByRoleCode } from '@/config/roles'

const SECURITY_ROLE_CODES = ['security_personel', 'dsm']

export default async (_to, _from, next) => {
  const user = store.getters['auth/user']
  const roleCode = extractRoleCode(user)

  if (!SECURITY_ROLE_CODES.includes(roleCode)) {
    next({ name: getHomeRouteByRoleCode(roleCode) })
  } else {
    next()
  }
}
